<template>
  <v-app>
    <div class="login">
      <v-row justify="center" style="margin-top:21vh">
        <v-col cols="12" md="4">
          <material-card color="#3949AB">
            <template v-slot:heading>
              <div class="display-2 font-weight-light" style="text-align:center">
                Welcome to XXX
              </div>

              <div class="subtitle-1 font-weight-light" style="text-align:center">
                Complete your profile
              </div>
            </template>

            <v-form ref="loginForm" v-model="loginForm" lazy-validation>
              <v-container class="py-0">
                <v-row style="padding:0px !important">
                  <v-col cols="12">
                    <v-text-field v-model="username" :rules="[GlobalRules.required, GlobalRules.counter_10, GlobalRules.spec]" prepend-inner-icon="mdi-account" placeholder="名前を入力してください" solo />
                  </v-col>
                  <v-col cols="12" style="padding-top:0px;">
                    <v-text-field prepend-inner-icon="mdi-lock" v-model="password" :rules="[GlobalRules.required, GlobalRules.counter_20]" placeholder="パスワードを入力してください" :type="show ? 'text' : 'password'" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" solo @click:append="show = !show" />
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="#3949AB" block class="mr-0" @click="login">
                      ログイン
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </material-card>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>
<script>
import materialCard from "../components/materialCard";

export default {
  components: {
    materialCard
  },
  data() {
    return {
      loading: false,
      show: false,
      loginForm: true,
      username: "admin",
      password: "123",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length <= 8) || "Password must be less than 8 characters"
      ]
    };
  },
  methods: {
    login() {
      var valid = this.$refs.loginForm.validate();

      if (valid) {
        this.loading = true;

        // let params = {
        //   username: this.username,
        //   password: this.password
        // };

        // this.postKeyValueRequest("/doLogin", params).then(resp => {
        //   this.loading = false;
        //   if (resp) {
        //     this.$store.commit("INIT_CURRENT_USER", resp.obj);
        //     window.sessionStorage.setItem("user", JSON.stringify(resp.obj));
        //     let path = this.$route.query.redirect;
        //     this.$router.replace(
        //       path == "/" || path == undefined ? "/home" : path
        //     );
        //   }
        // });
        var user = {
          userId: "admin",
          userName: "和田アキ子"
        };
        this.$store.commit("INIT_CURRENT_USER", user);
        window.sessionStorage.setItem("user", JSON.stringify(user));
        let path = this.$route.query.redirect;
        this.$router.replace(path == "/" || path == undefined ? "/home" : path);
      } else {
        this.$toast.open({
          message: "バリデーションチェックが不正です",
          type: "error"
        });
        return false;
      }
    },
    forget() {}
  }
};
</script>
<style  scoped>
.login {
  background-size: 100% 100%;
  height: 100vh;
}

a {
  text-decoration: none;
}

.forget:hover {
  color: #0069d9 !important;
}
</style>
